<form method="dialog">
  <button
    (click)="clearSelectedValues()"
    class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
  >
    ✕
  </button>
</form>

@if (loadingApiProducts) {
  <div class="my-4 text-center">
    <div class="loading loading-spinner loading-lg"></div>
  </div>
} @else if (errorFetchingApiProducts) {
  <p class="my-4 text-center text-error">
    {{ errorFetchingApiProducts }}
  </p>
} @else {
  <div class="card-title">Add API Subscription</div>
  <label class="form-control mt-4">
    <div class="label">
      <span class="label-text">API Product</span>
    </div>
    <select
      class="select select-bordered"
      placeholder="Select API Product"
      [(ngModel)]="selectedApiProduct"
    >
      <option selected value=""></option>
      @for (apiProduct of apiProducts; track apiProduct.id) {
        <option [ngValue]="apiProduct">
          {{ apiProduct.title }}
        </option>
      }
    </select>
  </label>

  <label class="form-control w-full max-w-xs py-2">
    <div class="label">
      <span class="label-text">Start Date</span>
    </div>
    <input
      [(ngModel)]="startDate"
      type="date"
      class="input input-bordered w-full max-w-xs"
    />
  </label>

  <div class="modal-action">
    <button
      (click)="addSubscription()"
      class="btn btn-primary"
      [disabled]="addingSubscription"
    >
      Add Subscription
    </button>
  </div>
  @if (errorAddingSubscription) {
    <p class="text-error">
      {{ errorAddingSubscription }}
    </p>
  }
}
